import React, { Component } from 'react';
class Hit extends Component {
        constructor(props) {
            super(props);
            this.state = {};
        }
         render() {
                    return  <a className="thumbnail thumbnail--tiny" href={this.props.absoluteUri}>
                                {this.props.image
                                    ? <img src={this.props.image} alt={this.props.title} />
                                    : <div className="thumbnail__placeholder" />}
                                {this.props.title}
                            </a>;
        }

}
export default Hit